import {WlBrandedButton} from "./button.component";
import { defineWebComponent } from "../webcomponents-utils";

export * from './button.component';
export default WlBrandedButton;

export const BUTTON_TAG = 'wl-branded-button';
defineWebComponent(BUTTON_TAG, WlBrandedButton);